<template>
  <div class="statistics-date-range">
    <div class="statistics-date-range__title  d-md-none">
      {{ $tStatistic('show_by_period') }}
    </div>

    <div class="statistics-date-range__period-wrap">
      <button v-if="dateRange"
              @click.prevent="onDateRangePrev"
              class="statistics-date-range__period-btn  _prev  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <button v-else
              disabled
              class="statistics-date-range__period-btn  _prev  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <BaseInput :value="dateRangeFormat"
                 readonly
                 @click.native="isOpen = true"
                 class="statistics-date-range__period-input  _white  _shadow"/>

      <button v-if="dateRange"
              @click.prevent="onDateRangeNext"
              class="statistics-date-range__period-btn  _next  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <button v-else
              disabled
              class="statistics-date-range__period-btn  _next  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
    </div>

    <transition name="dropdown">
      <div v-if="isOpen"
           v-click-out="() => (isOpen = false)"
           class="statistics-date-range__dropdown">
        <button type="button"
                class="statistics-date-range__dropdown-close"
                @click.prevent.stop="isOpen = false">
          <BaseSvg name="ico-close"
                   width=".8rem"
                   height=".8rem"/>
        </button>

        <div class="statistics-date-range__datepicker-wrap">
          <div class="statistics-date-range__datepicker">
            <div class="statistics-date-range__datepicker-inputs">
              <div class="statistics-date-range__datepicker-input-wrap">
                <input type="text"
                       :value="dateRange && dateRange[0]"
                       readonly
                       class="statistics-date-range__datepicker-input">
                <!--              <button @click.prevent="onClear"-->
                <!--                      class="statistics-date-range__datepicker-input-clear">-->
                <!--                <BaseSvg name="ico-close"/>-->
                <!--              </button>-->
              </div>
              <span class="statistics-date-range__datepicker-inputs-separator"> - </span>
              <div class="statistics-date-range__datepicker-input-wrap">
                <input type="text"
                       :value="dateRange && dateRange[1]"
                       readonly
                       class="statistics-date-range__datepicker-input">
                <!--              <button @click.prevent="onClear"-->
                <!--                      class="statistics-date-range__datepicker-input-clear">-->
                <!--                <BaseSvg name="ico-close"/>-->
                <!--              </button>-->
              </div>
            </div>
            <!--    <DatePiker :value="dateRange"-->
            <!--               format="DD.MM.YYYY"-->
            <!--               range-->
            <!--               range-separator=" - "-->
            <!--               value-type="format"-->
            <!--               @input="onDateRangeInput"-->
            <!--               class="statistics-date-range__period-datepicker"/>-->
          </div>
          <DatePicker :value="dateRange"
                      inline
                      range
                      format="DD.MM.YYYY"
                      value-type="format"
                      :lang="lang"
                      @input="onDateRangeInput"
                      class="statistics-date-range__datepicker">
          </DatePicker>
        </div>
        <StatisticsPageDatesRangeRangesList/>
      </div>
    </transition>
  </div>
</template>

<script>
  import datePickerMixin from '@/mixins/datePickerMixin'
  import StatisticsPageDatesRangeRangesList from './StatisticsPageDatesRangeRangesList'

  export default {
    name: 'StatisticsPageDatesRange',
    mixins: [datePickerMixin],
    components: {
      StatisticsPageDatesRangeRangesList
    },
    inject: [
      'FILTER_DATE_FROM',
      'FILTER_DATE_TO',
      'DEFAULT_DATE_RANGE',
      'DATE_RANGE_TYPE_KEY',
      'formatDate',
    ],
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      selectedDateRangeType() {
        return this.$route.query[this.DATE_RANGE_TYPE_KEY]
      },
      routeDateRange() {
        const query = this.$route.query

        return [query[this.FILTER_DATE_FROM], query[this.FILTER_DATE_TO]]
      },
      dateRange() {
        const routeDateRange = this.routeDateRange

        if (this.selectedDateRangeType === 'all') {
          if (!routeDateRange[0] || !routeDateRange[1]) {
            return null
          }
        } else {
          if (!routeDateRange[0] || !routeDateRange[1]) {
            return this.DEFAULT_DATE_RANGE
          }
        }

        return routeDateRange
      },

      dateRangeFormat() {
        return this.dateRange
            ? this.dateRange.join(' - ')
            : this.$tStatistic('input_value_all_period')
      }
    },
    methods: {
      onDateRangeInput([from, to]) {
        const query = {
          ...this.$route.query,
        }

        if (from && to) {
          query[this.FILTER_DATE_FROM] = from
          query[this.FILTER_DATE_TO] = to
        } else {
          delete query[this.FILTER_DATE_FROM]
          delete query[this.FILTER_DATE_TO]
        }

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      getDateRangeObjects() {
        const dateRange = this.dateRange

        return [getDate(dateRange[0]), getDate(dateRange[1])]
      },
      onDateRangePrev() {
        const dateRange = this.getDateRangeObjects()

        let from = dateRange[0]
        let to = dateRange[1]
        const diff = to - from
        // from.setFullYear(from.getFullYear() - 1)
        // to.setFullYear(to.getFullYear() - 1)
        from -= diff
        to -= diff

        this.onDateRangeInput([
          this.formatDate.format(from),
          this.formatDate.format(to)
        ])
      },
      onDateRangeNext() {
        const dateRange = this.getDateRangeObjects()

        let from = dateRange[0]
        let to = dateRange[1]
        const diff = to - from

        // from.setFullYear(from.getFullYear() + 1)
        // to.setFullYear(to.getFullYear() + 1)

        from = from.getTime() + diff
        to = to.getTime() + diff

        this.onDateRangeInput([
          this.formatDate.format(from),
          this.formatDate.format(to)
        ])
      },

      onClear() {

      }
    },
    created() {

    }
  }

  function getDate(str) {
    return new Date(
        parseFloat(str.slice(6, 10)),
        parseFloat(str.slice(3, 5)) - 1,
        parseFloat(str.slice(0, 2)),
    )
  }
</script>

<style lang="less">

</style>
